import {client} from '../../client';
import {TreeSettingsModel} from '../../../models/treeModelInnstillingWrapper';
import {AdmEnhet, ColumnSettings} from '../../../models';
import {IdentitetBilde} from '../../../models/identitetBilde';


export default class MeServices  {
    hentTreesetting = async (id : string) => client.get<TreeSettingsModel>( 'me/treesetting/' + id );
    setTreesetting = async (id : string,value: TreeSettingsModel) => client.post<TreeSettingsModel>( 'me/treesetting/' + id, value);
    setTableSettings = async (id : string,value: ColumnSettings) => client.post<ColumnSettings>( 'me/table/' + id, value);
    hentTableSettings = async (id : string) => client.get<ColumnSettings>( 'me/table/' + id );
    hentIdentitetBilde = async () => client.get<IdentitetBilde>('me/hentIdentitetBilde');
    isLocalBrukerAdministrator = async () => client.get<boolean>('me/erLokalBrukerAdministrator');
    lokalBrukerAdminAvdelinger = async () => client.get<AdmEnhet[]>('me/lokalBrukerAdministrator/avdelinger');
    isLocalTekstmalAdministrator = async () =>  await client.get<boolean>('me/erLokalTekstmalAdministrator');
    lokalTekstmalAdminAvdelinger = async () =>  await client.get<AdmEnhet[]>('me/lokalTekstmalAdministrator/avdelinger');
    varsleWebsakPluss = async () => client.get<ColumnSettings>('me/varsle_websak_pluss/');
    dbconnectionInfo = async () => client.get<ColumnSettings>('me/dbconnection/');

}